if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};
ShopifyAPI.onCartUpdate = function(cart) {
	console.log(cart);
};
ShopifyAPI.updateCartNote = function(note, callback) {
    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + attributeToString(note),
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                ShopifyAPI.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};
ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        //alert(data.message + '(' + data.status + '): ' + data.description);
    }
};
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item, form);
            } else {
                ShopifyAPI.onItemAdded(line_item, form);
            }
          
        $('body').trigger('added.ajaxProduct');
        },
        error: function(XMLHttpRequest, textStatus) {
            if ((typeof errorCallback) === 'function') {
                errorCallback(XMLHttpRequest, textStatus);
            } else {
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
        }
    };
    jQuery.ajax(params);
};
ShopifyAPI.getCart = function(callback) {
    jQuery.getJSON('/cart.js', function(cart, textStatus) {      
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
    });
};
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                ShopifyAPI.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};

$(document).on('click', '#AddToCartUpsell', function(evt){
  var varID = $(this).data("variantid");
  var qty = 1;

                evt.preventDefault();
  jQuery.ajax({
    type: "post",
    url: "/cart/add.js",
     data: {
        quantity: qty,
        id: varID,
        properties: {
            url: "immunity-support"
        }
    },
    dataType: "json",
    success: function(cart){
      ajaxCart.load();
    },
    error: function(n, r) {

    }
  });
});

$(document).on('click', '#cart_icon', function(evt){
  ajaxCart.load();
  timber.RightDrawer.open();
});


var ajaxCart = (function(module, $) {
    'use strict';
    var init, loadCart;
    var settings, isUpdating, $body;
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;
    init = function(options) {
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };
        $.extend(settings, options);
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);
        $body = $('body');
        isUpdating = false;
        if (settings.enableQtySelectors) {
            qtySelectors();
        }
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }
        adjustCart();
    };
    loadCart = function() {
        $body.addClass('drawer--is-loading'); 
        $('#CartContainer').hide();
        $('#cart-loading-spinner').show();
        ShopifyAPI.getCart(cartUpdateCallback);
    };
    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };
    formOverride = function() {

        $formContainer.on('submit', function(evt) {
            evt.preventDefault();
            $addToCart.removeClass('is-added').addClass('is-adding');
            $('.qty-error').remove();
            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
        });
    };
    itemAddedCallback = function(product) {
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(cartUpdateCallback);
    };
    itemErrorCallback = function(XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');
        if (!!data.message) {
            if (data.status == 422) {
                $formContainer.after('<div class="errors qty-error">' + data.description + '</div>')
            }
        }
    };
    cartUpdateCallback = function(cart) {
        updateCountPrice(cart);
      
      jQuery.getJSON('/cart.js', function(cart, textStatus) {
        let updatePromises = [];
        let handle_item = [];
        
          cart.items.forEach(function(item, index) {
          if (
            (item.handle == "mental-tranquility-sleep-samples" && item.quantity > 1) ||
            (item.handle == "cool-slumber-sleep-samples" && item.quantity > 1) ||
            (item.handle == "joint-vitality-samples" && item.quantity > 1)
          ) {
            handle_item = item.handle;
            
            let updatePromise = $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: {
                line: index + 1,
                quantity: 1
              },
              dataType: 'json'
            });

            updatePromises.push(updatePromise, handle_item); 
          }
        });

         if (updatePromises.length > 0) {
          Promise.all(updatePromises, handle_item)
            .then(function() {
              return $.getJSON('/cart.js');
            })
            .then(function(cart) {
              buildCart(cart, handle_item);
            })
            .catch(function(error) {
              console.error('Failed to update one or more gift products', error);
            });
        } else {
            buildCart(cart);
        }
          
      });
      
      
    };
    buildCart = function(cart, target) {      
        $cartContainer.empty();
        if (cart.item_count === 0) {
            $cartContainer.append('<p>' + "Your cart is currently empty." + '</p>');
           $('#CartCount').replaceWith("<span id='CartCount'>" + cart.item_count + "</span>");
            cartCallback(cart);
            return;
        }
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);
        var  offerProductExists = false;
    
        $.each(cart.items, function(index, cartItem) {
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }
          
          if(cartItem.properties != null && cartItem.properties['Pouches'] != null && cartItem.properties['Pouches']!= ''){
                var display_prop = cartItem.variant_title + ': ' + cartItem.properties['Pouches'] + ' Pouches (1 Pouch/Day)';
          }if(cartItem.properties != null && cartItem.properties['Details'] != null && cartItem.properties['Details']!= ''){
                var display_prop1 = 'Details: ' + cartItem.properties['Details'];
                display_prop = display_prop1.replace(/,\s*$/, "");
          }
          
            var varID = cartItem.variant_id;            
            var comparePrice;
            
          	if(varID == "50340663460140") {
                  offerProductExists = true;
            }
            $.ajax({ 
              url: '/products/' + cartItem.handle + '.js', 
              dataType: 'json',
              async: false, 
              success: function(product){ 
                product["compare_at_price"] = 0;
                product.variants.forEach(function(variant) {
                  if ( variant.id == varID && variant.compare_at_price !== 0){
                    comparePrice = variant.compare_at_price;
                                      console.log(variant.compare_at_price);
                    //has_sale = true;
                    return false;  
                    
                  }
                });
              },
              complete: function(){
                if( comparePrice == null || comparePrice < 1){
             // console.log('no sale on this item');
              comparePrice = '';
              var priceSaveO  = '';
              var priceSave  = '';
              var saveper = '';
            } else {
               var comparePriceO = comparePrice;
               comparePrice = Shopify.formatMoney(comparePriceO, settings.moneyFormat);
               var priceSaveO = comparePriceO-cartItem.price;
               var priceSave = Shopify.formatMoney(priceSaveO, settings.moneyFormat); 
               var div = document.createElement("div");
                div.innerHTML = priceSave;
                priceSave = div.textContent || div.innerText || "";
               var savePer = ((comparePriceO-cartItem.price)/cartItem.price)*100;
            }

            item = {
                id: cartItem.variant_id,
                line: index + 1,
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                handle: cartItem.handle,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                display_prop: display_prop,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                comparePrice: comparePrice,
                vendor: cartItem.vendor,
                priceSave: priceSave,
              savePer: Math.round(savePer)
            };
           }
          });
            items.push(item);
        });
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
            drawercartCount: cart.item_count
        }

        $cartContainer.append(template(data));
        if(offerProductExists) {
          $(".offer-product").hide();
        } else {
          $(".offer-product").show();
        }

        items.forEach(function(item) {
            if(item.handle == target){
              $('.ajaxcart__product[data-targethandle="' + target + '"] .sample_drawer_message').show();
            }
        });
      
        $cartContainer.find('span#drawercartCount').html(cart.item_count);
        $('#CartCount').replaceWith("<span id='CartCount'>" + cart.item_count + "</span>");
        cartCallback(cart);
    };
    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
      $('#CartContainer').show();
       $('#cart-loading-spinner').hide();
        $body.trigger('ajaxCart.afterCartLoad', cart);
    };
    adjustCart = function() {
      $body.on('click', '.ajaxcart__remove', function(){
            var $el = $(this),
                line = $el.data('remove-id'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt(0); 
            if (line) {
            	var $row_remove = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
                if (qty == 0) {
                  $row_remove.parent().addClass('is-removed');
                }
            }
            
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        
          
           var unlockOfferProduct = $(this).parents('.ajaxcart__product').data('name');
        setTimeout(function () {
            if (unlockOfferProduct == '/products/joint-vitality-offer?variant=48280263360812'){
             $("[data-name='/products/joint-vitality-welcome-kit?variant=48259025895724']").find('.ajaxcart__remove').trigger("click");
            }
           }, 400);
        
        });
      
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));
            var qty = validateQty(qty);
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });
        $body.on('change', '.ajaxcart__qty-num', function() {
         
            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));
            var qty = validateQty(qty);

          var handle_g = $el.data('handle');
          var new_q;
          if(handle_g == 'mental-tranquility-sleep-samples' || handle_g == 'cool-slumber-sleep-samples' || handle_g == 'joint-vitality-samples'){
            if(qty > 1){
              new_q = 1;
            }else{
               new_q = qty;
            }            
          }else{
            new_q = qty;
          }
   
            if (line) {
                updateQuantity(line, new_q);
            }
        });
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }
          //ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
            
            // setTimeout(function(){
            //   $.getJSON('/cart.js', function(cart) {
            //         $('#CartCount').replaceWith("<span id='CartCount'>" + cart.item_count + "</span>");
            //   });
            // },500);
         
        }
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };
    adjustCartCallback = function(cart) {
        isUpdating = false;
        updateCountPrice(cart);
        setTimeout(function() {
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };
    createQtySelectors = function() {
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();
                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;
                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        id: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };
                $el.after(template(data)).remove();
            });
        }
    };
    qtySelectors = function() {
        var numInputs = $('input[type="number"]');
        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');
                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;
                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        id: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };
                $el.after(template(data)).remove();
            });
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));
                var qty = validateQty(qty);
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }
                $qtySelector.val(qty);
            });
        }
    };
    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {} else {
            qty = 1;
        }
        return qty;
    };
    module = {
        init: init,
        load: loadCart
    };
    return module;
}(ajaxCart || {}, jQuery));